import { Injectable } from '@angular/core';
import { PurchaseRequestStatus } from '../enums';
import { OrderHistoryItem } from '../interfaces/order-history-item';
import { OrderHistoryTooltipData } from '../interfaces/order-history-tooltip-data';

@Injectable({ providedIn: 'root' })
export class PurchaseRequestOrderHistoryService {
  private readonly visibleStatuses = [
    PurchaseRequestStatus.AWAITING_FOR_APPROVAL,
    PurchaseRequestStatus.PENDING_INTEGRATION,
    PurchaseRequestStatus.QUOTED
  ];

  public getTooltipData(id: string, orders?: OrderHistoryItem[]): OrderHistoryTooltipData {
    return {
      id,
      items: orders ?? [],
      title: 'Pedidos',
      emptyLabel: 'Nenhum histórico encontrado'
    };
  }

  public shouldShowChip(status: PurchaseRequestStatus[], orders?: OrderHistoryItem[]): boolean {
    return (
      this.visibleStatuses.some(visibleStatus => status.includes(visibleStatus)) &&
      (orders?.length ?? 0) > 0
    );
  }
}
